<app-loader [status]="objLoaderStatus" *ngIf="objLoaderStatus"> </app-loader>
<router-outlet></router-outlet>
